const NAME = "EXTERNAL_DOCUMENTS_PAGE";

export default NAME;
